import React from "react";
import { Icons } from "../../components/common/Icons";
import { empSidebarItems } from "../../data/employeeData";
import SearchBar from "../../components/common/SearchBar";
import NotificationBell from "../../components/common/NotificationBell";
import { AvatarDisplay } from "../../components/common/AvatarUpload";
import { useEmployeeData } from "../../context/EmployeeContext";import "../../assets/styles/Employee/EmpTopbar.css";

function EmpTopbar({ active, setActive, onLogout, user, offboardingOnly = false }) {
  const { refreshEmployeeData, empNotifications } = useEmployeeData();
  const chatUnread = (empNotifications || []).filter((n) => (n.unread || !n.is_read) && String(n.type || '').toLowerCase() === 'chat').length;
  const label = empSidebarItems.find((i) => i.key === active)?.label || "Dashboard";
  return (
    <div className="topbar">
      <div className="topbar-breadcrumb">Employee Portal › <span>{label}</span></div>
      <div className="topbar-right">
        {!offboardingOnly &&
        <>
            <SearchBar portalName="Employee" resetKey={active} />
            <div onClick={() => setActive && setActive('chat')} title="Chat" className="emptopbar-inline-1">
              <Icons.Chat />
              {chatUnread > 0 && <span style={{ "--emptopbar-1-top": `${-6}px`, "--emptopbar-1-right": `${-8}px` }} className="emptopbar-dyn-1">{chatUnread > 99 ? '99+' : chatUnread}</span>}
            </div>
            <div className="emptopbar-inline-2">
              <NotificationBell onNavigate={(view) => setActive && setActive(view)} onMarkAllRead={refreshEmployeeData} />
            </div>
            <AvatarDisplay src={user?.avatar} name={user?.name} size={34} onClick={() => setActive && setActive('profile')} className="emptopbar-inline-3" />
          </>
        }
        <div className="topbar-icon-btn" onClick={onLogout} title="Sign Out"><Icons.Logout /></div>
      </div>
    </div>);

}

export default EmpTopbar;